import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-24 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-[#9d5a4d] mb-8">Who We Are</h2>
        <p className="text-lg text-gray-700 mb-8">
          Rueda de la Vida is a registered non-profit society dedicated to connecting communities through dance. 
          Founded in 2015, we started as a small dance group with a big dream. Over the years, we have grown in 
          size and reputation, bringing people together through the joy of dance in Vancouver.
        </p>
      </div>
    </section>
  );
};

export default About;
